var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadphones = function SvgIconHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.065 2.75a10 10 0 0 1 10.076 10V18a2.5 2.5 0 0 1-2.5 2.5h-1.5a2.5 2.5 0 0 1-2.5-2.5v-3.75a2.5 2.5 0 0 1 2.5-2.5h1.937a8 8 0 0 0-4.922-6.41 8 8 0 0 0-3.082-.59h-.016a8 8 0 0 0-7.995 7H6a2.5 2.5 0 0 1 2.5 2.5V18A2.5 2.5 0 0 1 6 20.5H4.5A2.5 2.5 0 0 1 2 18v-5.25a10 10 0 0 1 10.065-10M4 13.75V18a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5v-3.75a.5.5 0 0 0-.5-.5zm16.14 0h-2a.5.5 0 0 0-.5.5V18a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeadphones;